/**
 * Site-wide SEO and metadata configuration.
 * Use VITE_SITE_URL in .env for production canonical/base URL.
 */
import { STORE_DETAILS, ASSETS } from './store';

export const SITE_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) ||
  'https://bagbazarprovisionstores.com.np';

export const SEO = {
  defaultTitle: 'Bagbazar Provision Stores | Grocery Store in Pokhara-1, Bagbazar',
  shortTitle: 'Bagbazar Provision Stores',
  description:
    'Neighborhood provision store in Pokhara-1, Bagbazar, Kaski. Daily essentials, grains, and groceries. Open 6 AM–9 PM daily. Call +977-9819102869 for delivery.',
  keywords: [
    'provision store Pokhara',
    'grocery store Bagbazar',
    'groceries Pokhara-1',
    'Bagbazar Nepal',
    'daily essentials Kaski',
    'provision store Nepal',
    'Radhika Adhikari store',
  ].join(', '),
  ogImagePath: ASSETS.storeInterior1,
  ogImageAlt: 'Interior of Bagbazar Provision Stores in Pokhara-1, Bagbazar',
  twitterCard: 'summary_large_image' as const,
  locale: 'en_NP',
  themeColor: '#1d5fb0',
  geoRegion: 'NP-4',
  geoPlacename: 'Pokhara, Bagbazar',
} as const;

/** Build full absolute URL for a path (e.g. /images/logo.png -> https://.../images/logo.png) */
export function absoluteUrl(path: string): string {
  const base = SITE_URL.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
